/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Submitticket_Success1Inputs */

const en_support_submitticket_success1 = /** @type {(inputs: Support_Submitticket_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket has been successfully submitted`)
};

/**
* | output |
* | --- |
* | "Ticket has been successfully submitted" |
*
* @param {Support_Submitticket_Success1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const support_submitticket_success1 = /** @type {((inputs?: Support_Submitticket_Success1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Submitticket_Success1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_support_submitticket_success1(inputs)
});
export { support_submitticket_success1 as "support_submitTicket_success" }